<template>
  <div id="ReadMeView">
    <div class="about">
      <vue-markdown :source="md_source === '0' ? md_firmware : md_driver"></vue-markdown>
    </div>
  </div>
</template>
<script>
import VueMarkdown from "vue-markdown"
import EventBus from '@/store/eventBus'
const articleList_firmware = require("../assets/file/update_firmware.md")
const articleList_drive = require("../assets/file/update_drive.md")
export default {
  name: "ReadMeView",
  components: { VueMarkdown },
  data() {
    return {
      md_source: '0',
      md_firmware: articleList_firmware,
      md_driver: articleList_drive
    }
  },
  mounted() {
    EventBus.$on('updateRadioChange',this.getUpdateRadioChange)
  },
  methods: {
    getUpdateRadioChange(val) {
      if (val === '固件') {
        this.md_source = '0'
      } else {
        this.md_source = '1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #ReadMeView {
    width: 100%;
    height: 100%;
    border-radius: 0.1rem;
    box-sizing: border-box;
    padding: 0.2rem;
    text-align: left;
    overflow: auto;
    /deep/.about {
      display: flex;
      justify-content: center;
      ul {
        margin-bottom: 0.2rem;
        padding-left: 0.2rem;
        font-size: 0.2rem;
      }
      h2 {
        font-size: 0.3rem;
      }
      h3 {
        font-size: 0.2rem;
      }
    }
  }
</style>
